import {ClusteredCounts} from "../../ui/ClusterUI";
import {LabelUI} from "../../ui/LabelUI";
import {DispatchEventOnHover, HighlightDeferredOnHover, NestedMouseInteractionsPlugin, SelectDeferredOnClick} from "../../ui/plugins";
import {CONTENT_ANCHORING} from "../../ui/PositionedUI";
import {ClientPos2D} from "../../ui/positions";

import { av, THREE } from "@adsk/lmv";

const CLUSTER_REL_OFFSET = { top: '-10px', left: '100%' };

export class GlobalLabelUI extends LabelUI {
	constructor(hud, layer) {
		super(
			hud,
			layer,
			new ClientPos2D(new THREE.Vector2()),
			hud.twin.settings.props?.['Identity Data']?.['Building Name'] ?? 'Global target',
			CONTENT_ANCHORING.BOTTOM_CENTER);

		this.data.deferred = [];

		this.innerDom.classList.add('hud-global');

		this.plugins.push(new NestedMouseInteractionsPlugin());

		// Asset cluster integration
		this.assetsCounts = new ClusteredCounts(hud.getDocument(), CLUSTER_REL_OFFSET);
		this.assetsCounts.init(this.innerDom);
		this.assetsCounts.plugins.push(new SelectDeferredOnClick());
		this.assetsCounts.plugins.push(new HighlightDeferredOnHover());
		this.assetsCounts.plugins.push(new DispatchEventOnHover());

		this.children = [this.assetsCounts];

		// Position mid-bottom
		this.#reposition();
		this.boundOnResize = this.#reposition.bind(this);
	}

	updateWithDeferred(deferredAssets) {
		this.data.deferred.length = 0;
		for (const asset of deferredAssets) {
			this.data.deferred.push(asset)
		}

		this.assetsCounts.updateFromList(this.data.deferred);
		// the global target only exists for deferred assets, turn off if there are none.
		this.setVisible(deferredAssets.length > 0);
	}

	init(container) {
		super.init(container);
		this.hud.viewer.addEventListener(av.VIEWER_RESIZE_EVENT, this.boundOnResize);
	}

	dispose() {
		this.hud.viewer.removeEventListener(av.VIEWER_RESIZE_EVENT, this.boundOnResize);
		return super.dispose();
	}

	#reposition() {
		const { clientHeight, clientWidth } = this.hud.viewer.getCamera();
		this.position.setPos2D(clientWidth/2, clientHeight);
	}
}
